import { useContext } from 'react'

import { Box } from '@fairfashion/design-system'

import { BackButton } from '../../components/BackButton/back-button.comp'

import { CreateProductTraceabilityModal } from './components/CreateProductTraceabilityModal/create-product-traceability-modal.comp'
import { ProductHeader } from './components/ProductHeader/product-header.comp'
import { ProductItems } from './components/ProductItems/product-items.comp'
import {
  ProductDetailsContext,
  ProductDetailsProvider,
} from './product-details.context'

const ProductDetailsComp = () => {
  const { openAddItemModal, productDetails, actions } = useContext(
    ProductDetailsContext,
  )
  if (openAddItemModal)
    return (
      <CreateProductTraceabilityModal
        open={openAddItemModal}
        itemCode={productDetails?.code ?? ''}
        onClose={() => actions.setOpenAddItemModal(false)}
        onCreated={() => actions.getItems()}
      />
    )
  return (
    <Box width="100%" direction="column" gap={3} padding={3} paddingBottom={6}>
      <Box gap={2}>
        <BackButton url="/products" />
      </Box>

      <ProductHeader />
      <ProductItems />
    </Box>
  )
}
export const ProductDetails = () => {
  return (
    <ProductDetailsProvider>
      <ProductDetailsComp />
    </ProductDetailsProvider>
  )
}
